export default __webpack_public_path__ + "static/media/@danibonelli.683e0b81.png";